import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { firstValueFrom } from 'rxjs';
import { CausaliMovmagService } from 'src/app/shared/services/causali-movmag.service';
import saveAs from 'file-saver';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";

@Component({
  selector: 'app-causali-movmag',
  templateUrl: './causali-movmag.component.html',
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoLookupComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class CausaliMovmagComponent {
  private causaliService = inject(CausaliMovmagService);

  dataSource: any;
  srcSegno = [
    {
      value: 1,
      desc: '+',
    },
    {
      value: -1,
      desc: '-',
    },
  ];

  constructor() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.causaliService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.causaliService.post(values))
          .then(() => {
            this.causaliService.getListCausaliMovMagTemp(true).subscribe();
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.causaliService.remove(values))
            // .catch(() => { throw 'Deletion failed' });
            .then(() => {
              console.log('delete eseguito');
              this.causaliService.getListCausaliMovMagTemp(true).subscribe();
            })
            .catch((error: HttpErrorResponse) => {
              //throw 'Deletion failed'
              if(error?.error?.title){
                throw error.error.title;
              }
              else{
                throw "Errore cancellazione causale movimentazione";
              }
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.causaliService.update(key, values))
          .then(() => {
            this.causaliService.getListCausaliMovMagTemp(true).subscribe();
          })
          .catch((err: any) => {
            throw err.error.title;
          });
      },
    });
  }

  onUpdating(e: any) {
    // e.cancel = new Promise((resolve, reject) => {
    //   resolve('');
    // });
    for (const k in e.oldData) {
      if (e.newData[k] == undefined) {
        e.newData[k] = e.oldData[k];
      }
    }
  }

  valoreVerifica(valore: any) {
    return valore > 0;
  }

  onExporting(e: any) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Causali Movimentazioni');
  
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
  
        customizeCell: ({ gridCell, excelCell }) => {
          if (!gridCell) return;
          if (gridCell.rowType !== 'data') return;
          if (gridCell.column?.dataField === 'segno') {
            const v = gridCell.data?.segno > 0;
            
            if(v){
              excelCell.font = { color: { argb: 'FF1B5E20' } };
              excelCell.value = "POSITIVO";
            }
            else{
              excelCell.font = { color: { argb: 'FFB71C1C' } };
              excelCell.value = "NEGATIVO";
            }
    
            excelCell.alignment = { horizontal: 'center' };
          }
        },
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer: any) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            'Causali_Movimentazioni.xlsx',
          );
        });
      });
  
      e.cancel = true;
    }
}
